// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getAllDataComponentsPlayer = createAsyncThunk('appUsers/getAllDataComponentsPlayer', async id => {
  const response = await axios.get('https://apiv3.opentlv.com/api/v3/player/components/all',  { params: { id} })
  return response.data
})

export const getDataComponentsPlayer = createAsyncThunk('appUsers/getDataComponentsPlayer', async params => {
  const response = await axios.get('https://apiv3.opentlv.com/api/v3/player/components/data', {params})
  return {
    params,
    data: response.data.data,
    totalPages: response.data.total
  }
})

export const addComponent = createAsyncThunk('appUsers/addComponent', async (component, { dispatch, getState }) => {
  
  await axios.post('https://apiv3.opentlv.com/api/v3/player/components/add', component)
  await dispatch(getDataComponentsPlayer(getState().playerCompnents.params))
  
  return component
})
export const editComponent = createAsyncThunk('appUsers/editComponent', async (component, { dispatch, getState }) => {
  
  await axios.post('https://apiv3.opentlv.com/api/v3/player/components/edit', component)
  await dispatch(getDataComponentsPlayer(getState().playerCompnents.params))
  
  return component
})


export const deleteComponent = createAsyncThunk('appUsers/deleteComponent', async (id, { dispatch, getState }) => {
  console.log(getState().playerCompnents.params)
  await axios.delete('https://apiv3.opentlv.com/api/v3/player/component/delete', { params: { id} })
  await dispatch(getDataComponentsPlayer(getState().playerCompnents.params))

  return id
})
export const getUser = createAsyncThunk('appUsers/getUser', async id => {
  const response = await axios.get('https://apiv3.opentlv.com/api/v3/users/user', { params: { id} })
  console.log(response.data)
  return response.data
})

export const addUser = createAsyncThunk('appUsers/addUser', async (user, { dispatch, getState }) => {
  await axios.post('/apps/users/add-user', user)
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return user
})

export const deleteUser = createAsyncThunk('appUsers/deleteUser', async (id, { dispatch, getState }) => {
  await axios.delete('/apps/users/delete', { id })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return id
})

export const appClientsSlice = createSlice({
  name: 'appUsers',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedPlayer: null,
    selectedClient: null,
    selectedSite: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllDataComponentsPlayer.fulfilled, (state, action) => {
        state.allData = action.payload.components
        state.selectedPlayer = action.payload.player
        state.selectedSite = action.payload.site

      })
      .addCase(getDataComponentsPlayer.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })
  }
})

export default appClientsSlice.reducer
